import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app-module';

import 'moment';
import 'daterangepicker/daterangepicker.js';
import 'feather-icons';
import 'bootstrap';

// The router sends `/` to `/home` for a valid session, otherwise `/landing`.
// Reloading a non-root URL keeps that URL through the normal router bootstrap.

(window as any).MonacoEnvironment = {
  getWorkerUrl: function () {
    return 'assets/monaco/vs/base/worker/workerMain.js';
  },
  baseUrl: '/assets/monaco/vs/'
};

platformBrowser().bootstrapModule(AppModule, {
  
})
  .catch(err => console.error(err));
